export const locale = {
    lang: 'en',
    data: {
      'ALERTS':{
        'OK':'OK'
      },
      'SHEDULE': {
        'TITLE1': 'Register release date',
        'TITLE2': 'Register reminder',
        'TITLE3': 'Register close',
        'ERR01':'The reminders can not be minor than the launch day',
        'ERR02':'The reminders can not be  greater than the close day',
        'ERR03':'The reminders must in the course of survey',
        'ERR04':'you only can have 3 reminders',
        'ERR05':'The date can not be lower than now',
        'ERR06':'You already has send a email today',
        'SUC01':'Reminder save',
        'SELECT_DATE': 'Select a date',
        'SAVE': 'Save',
        'RECORDATORIOS': 'Reminders',
        'RECORDATORIO': 'Reminder', // Campo nuevo
        'ERRORDATE':'The date can not be prior that now', // Campo nuevo
        'SAMEDATE':'Choosing the current date as the survey launch date is not allowed',

        'LESSDAYS_T':'Are you sure to continue?',
        'LESSDAYS_I':'You need to schedule the survey launch date at least 15 days before the launch in order to the collaborators to receive the full communication plan.',
        'CONFLDATE_T':'Warning!',
        'CONFLDATE_I':'If you proceed you could not revert the survey launch date programming.',

        'FECHA': 'Date',
        'AGREGAR': 'Add',
        'EDITAR': 'Edit',
        'COMPLETAR_PASO': 'Complete step',
        'PASO_COMPLETADO': 'Step completed',
        'SUBIRLOGO': 'To create your survey you need to upload your company logo',
        'ACEPTARREQUERIMIENTOS': 'To create your survey it is necessary to accept the technical requirements',

        'SELECCIONE_FECHA': 'Please, select a date',
        'DATE_REGISTERED': 'Launch Date Registered Successfully',
        'CLOSE_REGISTERED': 'Close Date Registered Successfully',
        'CLOSE_MSJ1': 'The closing date must be greater than the release date',
        'CLOSE_MSJ2': 'Before registering close, you must register the Release date',
        'REMIDEROK': 'Reminder registered correctly',
        'REMIDER_MSJ1': 'The reminder must be greater than the release date',
        'REMIDER_MSJ2': 'Before registering a reminder you must register the Release date',
        'ESPERA_ENCUESTA': 'Wait, this may take a few minutes.',

        'ENCUESTA': 'Survey',
        'CREANDO_ENCUESTA': 'Creating survey...',
        'AGREGANDO_USUARIOS': 'Adding users...',
        'AGREGANDO_SECCION1': 'Adding NPS to the survey...',
        'AGREGANDO_SECCION2': 'Adding STATEMENTS to the survey...',
        'AGREGANDO_SECCION3': 'Adding CONTROL to the survey...',
        'AGREGANDO_SECCION4': 'Adding DEMOGRAPHICS to the survey...',
        'AGREGANDO_SECCION5': 'Adding ADDITIONAL to the survey...',
        'AGREGANDO_SECCION6': 'Adding CULTURAL PRACTICES to the survey...',
        'AGREGANDO_SECCION7': 'Adding Open questions to the survey...',
        'REINTENTAR': 'Retry',
        'ERROR_ENCUESTA': 'Error creating survey',
        'ERROR_USUARIOS': 'Error adding users...',
        'ERROR_SECCION1': 'Error adding NPS to survey...',
        'ERROR_SECCION2': 'Error adding STATEMENTS to the survey...',
        'ERROR_SECCION3': 'Error adding CONTROL to survey...',
        'ERROR_SECCION4': 'Error adding DEMOGRAPHICS to the survey...',
        'ERROR_SECCION5': 'Error adding ADDITIONAL to the survey...',
        'ERROR_SECCION6': 'Error adding CULTURAL PRACTICES to survey...',
        'ERROR_SECCION7': 'Error adding Open questions to survey...',

        'SUCCESS_ENCUESTA': 'Survey created successfully!',
        'SUCCESS_USUARIOS': 'Users added successfully!',
        'SUCCESS_SECCION1': 'NPS successfully added to the survey!',
        'SUCCESS_SECCION2': 'STATEMENTS successfully added to the survey!',
        'SUCCESS_SECCION3': 'CONTROL QUESTION successfully added to the survey!',
        'SUCCESS_SECCION4': 'DEMOGRAPHICS successfully added to the survey!',
        'SUCCESS_SECCION5': 'ADDITIONALS successfully added to the survey!',
        'SUCCESS_SECCION6': 'CULTURAL PRACTICES successfully added to the survey!',
        'SUCCESS_SECCION7': 'Open questions successfully added to the survey!',
        'BTN_CREARENCUESTA': 'Create survey',

        'CONTINUE_FINISH': 'Survey created successfully, you can finish the step.',
        'LAUNCH_SURVEY': 'Please, create the surver to complete the step',
        'PULSE':{
            //Shedule survey
          'MES1': ' Pulse Check month 1',
          'MES2': ' Pulse Check month 2',
          'MES3': ' Pulse Check month 3',
          'MES4': ' Pulse Check month 4',
          'MES5': ' Pulse Check month 5',
          'MES6': ' Pulse Check month 6',
          'MES7': ' Pulse Check month 7',
          'MES8': ' Pulse Check month 8',
          'MES9': ' Pulse Check month 9',
          'MES10': ' Pulse Check month 10',
          'MES11': ' Pulse Check month 11',
          'MES12': ' Pulse Check month 12',
          'INDICA': 'Select the pulse check date',
          'INDICA_GENERA':'Generate Survey',
          'SUBINDICA_GENERA':'Click to generate survey',


             },



      },
    }
};
